/**
 * getGreeting - Returns a time-of-day appropriate greeting
 *
 * 3:00 AM – 11:59 AM  → Good Morning
 * 12:00 PM – 5:59 PM  → Good Afternoon
 * 6:00 PM – 2:59 AM   → Good Evening
 */
export const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 3 && hour < 12) return 'Good Morning';
    if (hour >= 12 && hour < 18) return 'Good Afternoon';
    return 'Good Evening';
};
